"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { MatchEvents } from "../partials/events/MatchEvents";
interface EventsTabProps {
  homeTeamName: string;
  awayTeamName: string;
  homeTeamLogo?: string;
  awayTeamLogo?: string;
  homeTeamCountryCode?: string;
  homeTeamCountryFlag?: string;
  homeTeamPrimaryColor?: string;
  homeTeamSecondaryColor?: string;
  awayTeamCountryCode?: string;
  awayTeamCountryFlag?: string;
  awayTeamPrimaryColor?: string;
  awayTeamSecondaryColor?: string;
}

/**
 * EventsTab - Displays match events timeline
 * Shows goals, cards, substitutions, etc.
 */
export const EventsTab: React.FC<EventsTabProps> = t0 => {
  const $ = _c(13);
  const {
    homeTeamName,
    awayTeamName,
    homeTeamLogo,
    awayTeamLogo,
    homeTeamCountryCode,
    homeTeamCountryFlag,
    homeTeamPrimaryColor,
    homeTeamSecondaryColor,
    awayTeamCountryCode,
    awayTeamCountryFlag,
    awayTeamPrimaryColor,
    awayTeamSecondaryColor
  } = t0;
  let t1;
  if ($[0] !== awayTeamCountryCode || $[1] !== awayTeamCountryFlag || $[2] !== awayTeamLogo || $[3] !== awayTeamName || $[4] !== awayTeamPrimaryColor || $[5] !== awayTeamSecondaryColor || $[6] !== homeTeamCountryCode || $[7] !== homeTeamCountryFlag || $[8] !== homeTeamLogo || $[9] !== homeTeamName || $[10] !== homeTeamPrimaryColor || $[11] !== homeTeamSecondaryColor) {
    t1 = <div className="max-w-3xl mx-auto"><MatchEvents homeTeamName={homeTeamName} awayTeamName={awayTeamName} homeTeamLogo={homeTeamLogo} awayTeamLogo={awayTeamLogo} homeTeamCountryCode={homeTeamCountryCode} homeTeamCountryFlag={homeTeamCountryFlag} homeTeamPrimaryColor={homeTeamPrimaryColor} homeTeamSecondaryColor={homeTeamSecondaryColor} awayTeamCountryCode={awayTeamCountryCode} awayTeamCountryFlag={awayTeamCountryFlag} awayTeamPrimaryColor={awayTeamPrimaryColor} awayTeamSecondaryColor={awayTeamSecondaryColor} /></div>;
    $[0] = awayTeamCountryCode;
    $[1] = awayTeamCountryFlag;
    $[2] = awayTeamLogo;
    $[3] = awayTeamName;
    $[4] = awayTeamPrimaryColor;
    $[5] = awayTeamSecondaryColor;
    $[6] = homeTeamCountryCode;
    $[7] = homeTeamCountryFlag;
    $[8] = homeTeamLogo;
    $[9] = homeTeamName;
    $[10] = homeTeamPrimaryColor;
    $[11] = homeTeamSecondaryColor;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
};